import React from "react";
import { NumberInput, TextInput } from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";
import { facilitySchema } from "../../validation/facilitySchema";

function FinancialSetup({ errorMessage, setErrorMessage }) {
  const dispatch = useDispatch();

  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);

  const handleChange = (e) => {
    let facilityData = { ...facilityInformationData };
    const { name, value } = e?.target;
    facilityData[name] = value;
    dispatch(facilityAction?.setFacilityData(facilityData));
  };

  const handleBlurFinancialInfo = async (e) => {
    let { name, value } = e.target;
    let facilityData = { ...facilityInformationData };

    try {
      // Clear error if validation passes
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "", // Clear the specific field error
      }));
      facilityData[name] = value ? value.trim() : "";
      dispatch(facilityAction?.setFacilityData(facilityData));
      // Validate the field using the Joi schema and handle both required and other validation
      let objField = { [name]: value };

      await facilitySchema.validateAsync(
        {
          ...objField,
          IsMessageAcess: facilityInformationData?.IsMessageAcess,
          IsPhotoAccess: facilityInformationData?.IsPhotoAccess,
          IsEmojiEnabled: facilityInformationData?.IsEmojiEnabled,
          IsEcardAccess: facilityInformationData?.IsEcardAccess,
        },
        { abortEarly: false },
      );
    } catch (err) {
      // Find the error that matches the current field name
      const fieldError = err.details.find((error) => error.path.includes(name));

      if (fieldError) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError.message, // Set the specific field error from Joi
        }));
      }
    }
  };

  return (
    <div className="mt-3 mb-3">
      <h4
        className="inner-header-bg text-color"
        style={{ cursor: "pointer" }}
        title="To charge the public user or inmate on sending message, photo or e-card."
      >
        <i className="fas fa-briefcase me-2"></i>Financial Setup
      </h4>
      <div className="row mb-3">
        <div className="col-sm-6 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <NumberInput
              name="FacilityMessageCost"
              id="message_cost"
              label="Message Cost ($)"
              required={
                facilityInformationData?.IsMessageAcess === 1 ? true : false
              } // Only make required if the field is enabled
              handleChange={handleChange}
              placeholder="0.50"
              errorMessage={errorMessage}
              value={facilityInformationData?.FacilityMessageCost}
              disabled={!facilityInformationData?.IsMessageAcess}
              handleBlur={handleBlurFinancialInfo}
              maxLength={4}
              maxValue={99}
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <NumberInput
              name="FacilityPhotoCost"
              id="photo_cost"
              label="Photo Cost ($)"
              value={facilityInformationData?.FacilityPhotoCost}
              handleChange={handleChange}
              placeholder="1.00"
              errorMessage={errorMessage}
              disabled={!facilityInformationData?.IsPhotoAccess}
              required={
                facilityInformationData?.IsPhotoAccess === 1 ? true : false
              }
              handleBlur={handleBlurFinancialInfo}
              maxLength={4}
              maxValue={99}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <NumberInput
              name="FacilityEcardCost"
              id="FacilityEcardCost"
              label="E-Card Cost ($)"
              value={facilityInformationData?.FacilityEcardCost}
              handleChange={handleChange}
              placeholder="1.00"
              errorMessage={errorMessage}
              disabled={!facilityInformationData?.IsEcardAccess}
              required={
                facilityInformationData?.IsEcardAccess === 1 ? true : false
              }
              handleBlur={handleBlurFinancialInfo}
              maxLength={4}
              maxValue={99}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <NumberInput
              name="FacilityEmojiCost"
              id="emoji_cost"
              label="Emoji Cost ($)"
              //value={parseFloat(facilityInformationData?.FacilityEmojiCost)}
              value={facilityInformationData?.FacilityEmojiCost}
              handleChange={handleChange}
              placeholder="0.10"
              errorMessage={errorMessage}
              disabled={
                facilityInformationData?.IsMessageAcess === 1 ||
                facilityInformationData?.IsPhotoAccess === 1
                  ? !facilityInformationData?.IsEmojiEnabled
                  : true
              }
              //required={false}
              required={
                (facilityInformationData?.IsMessageAcess === 1 ||
                  facilityInformationData?.IsPhotoAccess === 1) &&
                facilityInformationData?.IsEmojiEnabled == 1
                  ? true
                  : false
              }
              handleBlur={handleBlurFinancialInfo}
              maxLength={4}
              maxValue={99}
            />
          </div>
        </div>

        {/* Facility Audio/Video Cost */}
        {/* <div className="col-sm-6 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <NumberInput
              name="FacilityAudioVideoCost"
              id="emoji_cost"
              label="Audio/Video Call Cost ($)"
              value={facilityInformationData?.FacilityAudioVideoCost}
              handleChange={handleChange}
              placeholder="0.10"
              errorMessage={errorMessage}
              disabled={false}
              //required={false}
              required={true}
              handleBlur={handleBlurFinancialInfo}
              maxLength={4}
              maxValue={99}
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <NumberInput
              name="FacilityAudioCost"
              id="emoji_cost"
              label="Only Audio Call Cost ($)"
              value={facilityInformationData?.FacilityAudioCost}
              handleChange={handleChange}
              placeholder="0.10"
              errorMessage={errorMessage}
              disabled={false}
              //required={false}
              required={true}
              handleBlur={handleBlurFinancialInfo}
              maxLength={4}
              maxValue={99}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default React.memo(FinancialSetup);
